module.exports = __webpack_public_path__ + "img/william-wells-brown.1cf62c38.png";